import type { ApiScanVideoSubmission } from '@kaiizen/kai-pro-api';
import { useEffect, useState } from 'react';

import { useKaiProApiClient } from '@/Client/State';

export const useFocusedMediaStripVideoSubmissions = (
  videoIds: readonly string[],
): {
  submissionsByVideoId: Record<string, ApiScanVideoSubmission>;
  isLoadingVideos: boolean;
} => {
  const kaiProApiClient = useKaiProApiClient();
  const [submissionsByVideoId, setSubmissionsByVideoId] = useState<Record<string, ApiScanVideoSubmission>>({});
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);

  useEffect(() => {
    if (!videoIds.length) {
      setSubmissionsByVideoId({});
      return;
    }

    let cancelled = false;
    setIsLoadingVideos(true);

    void Promise.all(
      videoIds.map(videoId =>
        kaiProApiClient.getScanVideo(videoId)
          .then(submission => ({ videoId, submission }))
          .catch(() => null)
      ),
    )
      .then(results => {
        if (cancelled) return;
        const submissions: Record<string, ApiScanVideoSubmission> = {};
        for (const result of results) {
          if (result) submissions[result.videoId] = result.submission;
        }
        setSubmissionsByVideoId(submissions);
      })
      .finally(() => {
        if (!cancelled) setIsLoadingVideos(false);
      });

    return () => {
      cancelled = true;
    };
  }, [kaiProApiClient, videoIds]);

  return { submissionsByVideoId, isLoadingVideos };
};
